/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Venue_DefaultInputs */

const cs_settings_teams_venue_default = /** @type {(inputs: Settings_Teams_Venue_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prázdné = vaše pobočka`)
};

const en_settings_teams_venue_default = /** @type {(inputs: Settings_Teams_Venue_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empty = your branch`)
};

/**
* | output |
* | --- |
* | "Empty = your branch" |
*
* @param {Settings_Teams_Venue_DefaultInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_venue_default = /** @type {((inputs?: Settings_Teams_Venue_DefaultInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Venue_DefaultInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_venue_default(inputs)
	return cs_settings_teams_venue_default(inputs)
});